import type { ComponentPropsWithoutRef } from 'react';

import { PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

type FilterTriggerProps = ComponentPropsWithoutRef<typeof PopoverTrigger> & {
  title: string;
};

export const FilterTrigger = ({
  title,
  children,
  className,
  chevronClassName,
  ...props
}: FilterTriggerProps) => (
  <PopoverTrigger
    showChevron
    chevronClassName={cn('text-jb-neutral-700', chevronClassName)}
    className={cn(
      'flex w-full items-center justify-between gap-2 px-4 py-1.5 [&>div]:w-full',
      className
    )}
    {...props}
  >
    <div className="flex flex-1 flex-col items-start gap-px text-left">
      <span className="text-jb-body-xsmall text-jb-neutral-800">{title}</span>
      <span className="text-jb-body-small font-medium text-jb-neutral-900">
        {children}
      </span>
    </div>
  </PopoverTrigger>
);
